<template>
	<div>
		<span v-if="tradable.quality.paper_fixed != null">{{
			__(tradable.quality.paper_fixed)
		}}</span>

		<div v-else>
			<span
				v-if="tradable.product.quality_standard_id === null"
				class="inline-flex items-center"
			>
				<font-awesome-icon
					:icon="['fas', 'triangle-exclamation']"
					class="mr-2 h-5 w-5 text-red-600"
				/>
				<span class="badge badge-primary text-red-600">{{
					__("Specific Quality")
				}}</span>
			</span>
			<span v-else>{{ __("Standard Quality") }}</span>

			<ul :class="ulClass">
				<li
					:class="[liClass, qualityColoring(param)]"
					v-for="(param, idx) in qualityParameters"
					:key="idx"
				>
					{{ __(param.name) }}:
					<span v-if="param.type == 'checkbox'">
						<span v-if="tradable.quality[param.id] == '1'">{{
							__("Yes")
						}}</span>
						<span v-else>{{ __("No") }}</span>
					</span>
					<span v-else>
						<span v-if="tradable.quality[param.id]">
							{{ __(tradable.quality[param.id]) }} {{ __(param.suffix) }}
							<ui-icon
								:name="
									qualityColoring(param).includes('black')
										? 'check'
										: qualityColoring(param).includes('red')
										? 'x'
										: ''
								"
								stroke-width="2"
								class="inline-block w-3 h-3"
							/>
							<span
								v-if="hasReference(param) && showReferenceStrikethrough"
								class="line-through"
							>
								{{ referenceTradable.quality[param.id] }}
								{{ __(param.suffix) }}</span
							>
							<span
								v-if="qualityStandardValues[param.id] && showDifferences(param)"
							>
								&nbsp; (Standard: {{ __(qualityStandardValues[param.id]) }}
								{{ __(param.suffix) }})
							</span>
						</span>

						<span v-else>{{ __("n.a.") }}</span>
					</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		tradable: {
			type: Object,
			required: true,
		},
		referenceTradable: {
			type: Object,
			required: false,
		},
		liClass: {
			type: String,
			default: "",
		},
		ulClass: {
			type: String,
			default: "",
		},
		showReferenceStrikethrough: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		qualityParameters: function () {
			let parameters = this.$cropOptions.getProductQualityParameters(
				this.tradable.product.type,
				this.tradable.product.grade
			);

			// GMP+/FSA nur bei "Ja" zeigen (wie Tradable::getQualityTable) — kein ausgeschriebenes "Nein".
			return parameters.filter(
				(parameter) =>
					parameter.id !== "gmp_certified" ||
					this.tradable.quality.gmp_certified == "1"
			);
		},
		qualityStandardValues() {
			let grade = this.tradable.product.grade.split("__")[0];
			return (this.$cropOptions.qualityStandardOptions[grade] ?? [{}])[0];
		},
	},
	methods: {
		isBigger: function (param) {
			if (this.referenceTradable)
				return (
					this.tradable.quality[param.id] >
					this.referenceTradable.quality[param.id]
				);
		},
		showDifferences: function (param) {
			return (
				this.tradable.product.quality_standard_id === null &&
				this.tradable.quality[param.id] != param.default
			);
		},
		isSmaller: function (param) {
			if (this.referenceTradable)
				return (
					this.tradable.quality[param.id] <
					this.referenceTradable.quality[param.id]
				);
		},
		hasReference(param) {
			if (
				!this.referenceTradable ||
				this.referenceTradable.quality[param.id] == null
			) {
				return false;
			} else {
				return (
					this.referenceTradable.quality[param.id] !=
					this.tradable.quality[param.id]
				);
			}
		},
		qualityColoring: function (param) {
			if (
				!this.referenceTradable ||
				this.referenceTradable.quality[param.id] == null
			) {
				if (this.tradable.product.quality_standard_id === null) {
					return "text-red-600";
				} else {
					return "";
				}
			}
			let bigger =
					1 * this.tradable.quality[param.id] >
					1 * this.referenceTradable.quality[param.id],
				smaller =
					1 * this.tradable.quality[param.id] <
					1 * this.referenceTradable.quality[param.id],
				equal =
					this.tradable.quality[param.id] ==
					this.referenceTradable.quality[param.id],
				biggerIsBetter = param.prefix == "min",
				smallerIsBetter = param.prefix == "max";

			if (
				this.tradable.quality[param.id] == null &&
				this.referenceTradable.quality[param.id] != null
			) {
				return "text-red-600";
			}

			if (
				(biggerIsBetter && this.tradable.trade == "BUY") ||
				(smallerIsBetter && this.tradable.trade == "SELL")
			) {
				return (
					(smaller ? "text-black-500" : "") + (bigger ? "text-red-600" : "")
				);
			} else if (
				(biggerIsBetter && this.tradable.trade == "SELL") ||
				(smallerIsBetter && this.tradable.trade == "BUY")
			) {
				return (
					(smaller ? "text-red-600" : "") + (bigger ? "text-black-500" : "")
				);
			} else {
				// some params can't be compared like that
				return "";
			}
		},
	},
};
</script>
